import { environment } from '../../../environments/environment';

export const SECURED_CCF_API_PATHS = [
  '/management',
  '/news-articles',
  '/discounts',
  '/eba',
  '/export-tool',
  '/exports',
  '/eba',
  '/excel/equipment',
] as const;

export const isSecuredCcfApiRequest = (url: string): boolean =>
  url.startsWith(environment.apiBaseUrl) && SECURED_CCF_API_PATHS.some((path) => url.includes(path));

export const isAdministrationApiRequest = (url: string): boolean =>
  url.startsWith(environment.apiBaseUrl) && url.includes('/management');
